import type { AdvertisingBanner } from '../../Header/interfaces';

export const getAdvertisingBannerImage = (adBanner?: AdvertisingBanner | null) =>
  adBanner?.image || adBanner?.bynderAdvertisingBannerImage || adBanner?.advertisingBannerImage || null;

export const getAdvertisingBannerAlt = (adBanner?: AdvertisingBanner | null, fallback = '') => {
  const image = getAdvertisingBannerImage(adBanner);

  return (
    image?.bynderImage?.alt ||
    image?.alt ||
    adBanner?.bynderAdvertisingBannerImage?.alt ||
    adBanner?.advertisingBannerImage?.alt ||
    fallback
  );
};
